import { CreateServiceCategoryRequestDTO, ServiceCategoryResponseDTO } from 'typings/dto/serviceCategory';
import ModelActionsService from '../ModelActionsService';
import IServiceCategoryActionsService from './IServiceCategoryActionsService';

export default class ServiceCategoryActionsServiceImpl
  extends ModelActionsService<ServiceCategory, CreateServiceCategoryRequestDTO, ServiceCategoryResponseDTO>
  implements IServiceCategoryActionsService {}
